<div style="position: relative; width: 100%; height:100%;" (mouseleave)="pause()" (mouseenter)="resume()">
  <div #chart id="chart" style="width: 100%; height: 100%"></div>
  <div #toolTipAnchor id="toolTipAnchor" [matTooltip]="'CHART.TOOLTIP' | translate"
       matTooltipClass="multiline-tooltip"
       matTooltipPosition="above"
       [ngStyle]="{'top.px': toolTipY, 'left.px': toolTipX}">
  </div>
</div>
